import { Component, Input, OnChanges } from "@angular/core";
import {
    AssignedItemMeta,
    EMPTY_ASSIGNED_ITEM_META,
} from "@/_services/assigned-item-meta.service";

const FIXED_WIDTH_CLASSES = "flex-none white-space-nowrap";
const TRUNCATING_CLASSES =
    "flex-shrink-1 min-w-0 overflow-hidden text-overflow-ellipsis white-space-nowrap";

interface MetaPart {
    text: string;
    styleClass: string;
}

@Component({
    selector: "app-assigned-item-meta",
    standalone: true,
    templateUrl: "./assigned-item-meta.component.html",
    host: { class: "block min-w-0" },
})
export class AssignedItemMetaComponent implements OnChanges {
    @Input() meta: AssignedItemMeta = EMPTY_ASSIGNED_ITEM_META;

    parts: MetaPart[] = [];

    ngOnChanges(): void {
        this.parts = [
            { text: this.meta.publicId, styleClass: FIXED_WIDTH_CLASSES },
            { text: this.meta.context, styleClass: TRUNCATING_CLASSES },
            { text: this.meta.date, styleClass: FIXED_WIDTH_CLASSES },
        ].filter((part) => part.text);
    }
}
